import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { useSavedContentQuery } from '../../api';
import { SavedContentContext } from '../../context';

export interface SavedContentProviderProps {
  contentIds?: string[];
  children: ReactNode;
}

export function SavedContentProvider({ contentIds = [], children }: SavedContentProviderProps) {
  const savedContentQuery = useSavedContentQuery(
    {
      page: 1,
      items: contentIds.length,
      sortDirection: 'asc',
      sortCol: 'createdAt',
      contentIds,
    },
    { enabled: contentIds.length > 0 },
  );

  const contextValue = useMemo(
    () => ({
      savedContentIds: savedContentQuery.data?.results.map(({ content }) => content.id) ?? [],
      isLoading: savedContentQuery.isInitialLoading,
    }),
    [savedContentQuery.data, savedContentQuery.isInitialLoading],
  );

  return <SavedContentContext.Provider value={contextValue}>{children}</SavedContentContext.Provider>;
}
